export default [
  {
    path: "/privacy-policy-statement",
    name: "PrivacyPolicyStatement",
    component: () => import("./views/PrivacyPolicyStatementView.vue"),
    props: true
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditions",
    component: () => import("./views/TermsAndConditionsView.vue"),
    props: true
  },
  {
    path: "/important-notices",
    name: "ImportantNotices",
    component: () => import("./views/ImportantNoticesView.vue"),
    props: true
  }
];
